import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


//import { CreateQuestionnaireComponent, ModelCreationComponent, QuestionnaireComponent, ResultComponent, ResultELComponent, ApprenantComponent } from './';

import { CreateQuestionnaireComponent } from './CreateQuestionnaire/createQuestionnaire.component';
import { ModelCreationComponent } from './ModelQuestionnaire/modelCreation.component';
import { QuestionnaireComponent } from './Questionnaire/questionnaire.component';
import { ResultComponent } from './result/result.component';
import { ResultELComponent } from './result-el/result-el.component';
import { ApprenantComponent } from './apprenant/apprenant.component';

const QuestionnaireRoutes: Routes = [
  {
    path: 'questionnaire', children: [
      { path: 'create', component: CreateQuestionnaireComponent },
      { path: 'answer', component: QuestionnaireComponent },
      { path: 'model', component: ModelCreationComponent },
    ]
  },
 {
    path: 'trainer', children: [
      { path: 'result', component: ResultComponent },
      { path: 'result-el', component: ResultELComponent },
    ]
  },
  {
     path: 'learner', children: [
      { path: '', component: ApprenantComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(QuestionnaireRoutes)],
  exports: [RouterModule],
})
export class QuestionnaireRoutingModule { }
